import { createFileRoute } from "@tanstack/react-router";
import IMEI from "@/features/assessments/device/pages/Imei";

export const Route = createFileRoute("/$locale/$partner/_device/imei")({
	component: IMEI,
});
